import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { movies } from "@/mocks/movies";
import { formatViews } from "@/utils/movieHelpers";

export default function LatestHotSection() {
  const latest = [...movies]
    .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
    .slice(0, 5);
  const hot = [...movies].sort((a, b) => b.views - a.views).slice(0, 5);

  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-12">
        <div>
          <SectionHeading
            eyebrow="LATEST"
            title="最新资讯与更新"
            subtitle="刚刚上线或更新的影视内容，第一时间了解作品动态。"
          />
          <div className="flex flex-col gap-3">
            {latest.map((movie) => (
              <Link
                key={movie.id}
                to={`/detail/${movie.id}`}
                className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-all duration-300 hover:border-primary-300 cursor-pointer"
              >
                <div className="relative h-20 w-14 shrink-0 overflow-hidden rounded-md bg-background-200">
                  <img
                    src={movie.poster}
                    alt={movie.title}
                    title={`${movie.title} - 剧情解析`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900 whitespace-nowrap">
                      {movie.type === "movie" ? "电影" : "电视剧"}
                    </span>
                    <span className="text-xs text-foreground-400">更新于 {movie.updatedAt}</span>
                  </div>
                  <h3 className="mt-1.5 truncate text-sm font-medium text-foreground-950 group-hover:text-primary-600 transition-colors md:text-base">
                    {movie.title}
                  </h3>
                  <p className="mt-1 truncate text-xs text-foreground-500">{movie.summary}</p>
                </div>
                <i className="ri-arrow-right-s-line shrink-0 text-xl text-foreground-300 transition-transform group-hover:translate-x-1 group-hover:text-primary-500" />
              </Link>
            ))}
          </div>
        </div>

        <div>
          <SectionHeading
            eyebrow="TRENDING"
            title="热门推荐"
            subtitle="根据站内浏览量排行，影迷最关注的五部作品。"
          />
          <div className="flex flex-col gap-3">
            {hot.map((movie, i) => (
              <Link
                key={movie.id}
                to={`/detail/${movie.id}`}
                className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-all duration-300 hover:border-accent-300 cursor-pointer"
              >
                <span
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md text-base font-bold ${
                    i < 3
                      ? "bg-accent-500 text-background-50"
                      : "bg-background-200 text-foreground-600"
                  }`}
                >
                  {i + 1}
                </span>
                <div className="min-w-0 flex-1">
                  <h3 className="truncate text-sm font-medium text-foreground-950 group-hover:text-accent-600 transition-colors md:text-base">
                    {movie.title}
                  </h3>
                  <p className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
                    <span className="whitespace-nowrap">{movie.year} · {movie.region}</span>
                    <span className="whitespace-nowrap">
                      <i className="ri-fire-line mr-1 text-accent-500" />
                      {formatViews(movie.views)} 浏览
                    </span>
                  </p>
                </div>
                <span className="flex shrink-0 items-center gap-1 rounded-md bg-secondary-100 px-2 py-1 text-xs font-bold text-secondary-900">
                  <i className="ri-star-fill" />
                  {movie.rating.toFixed(1)}
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}